module.exports = {"svg":{"$":{"viewBox":"0 0 253 253","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"path":[{"$":{"d":"M253.025233 11.212093 241.783488 0 126.503721 115.291628 11.2318605 0 0 11.2318605 115.289651 126.503721 0.0197674419 241.783488 11.2318605 253.025233 126.521512 137.745465 241.783488 253.005465 253.025233 241.783488 137.743488 126.503721z"}}]}}


//////////////////
// WEBPACK FOOTER
// ./~/xml-loader!./src/svg/icon-cross.svg
// module id = 494
// module chunks = 0